import Aos from "../components/aos";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import HeroSlider from "../components/HeroSlider";
import SlickSlider from "../components/SlickSlider";
import CtaScrollSection from "../components/CtaScrollSection";
import TicketsSection from "../components/TicketsSection";
import renderMarquee from "../actions/renderMarquee";
import FloatingShapes from "../components/FloatingShapes";
import renderCountDownTimer from "../actions/renderCountDownTimer";
/**
 * Front Page
 */
const PageFrontPage = ($) => {
	if ($("body").hasClass("home")) {
		Aos();

		gsap.registerPlugin(ScrollTrigger); // intialize scrollTrigger using Gsap and pass down
		HeroSlider($); // handles slider logic
		SlickSlider($, "experience-slider");
		TicketsSection(gsap); // handles scroll scrubbing for pictures
		CtaScrollSection(gsap, ScrollTrigger, $); // handles pinning the section on screen
		renderMarquee($);
		FloatingShapes(gsap, 2);
		renderCountDownTimer($);
	}
};

export default PageFrontPage;
